import Decimal from 'decimal.js';

export const discountDefault = () => ({ kind: 'percent', value: '0' });
const moneyFormatter = new Intl.NumberFormat('id-ID', { maximumFractionDigits: 2 });
export const moneyText = value => 'Rp ' + moneyFormatter.format(Number(value || 0));
export const decimalInput = value => String(value ?? '').replace(',', '.');
const decimal = value => new Decimal(value === '' || value == null ? 0 : value);
export const multiplyMoney = (left, right) => decimal(left).mul(decimal(right)).toFixed();
export const divideMoney = (left, right) => decimal(right).isZero() ? '0' : decimal(left).div(decimal(right)).toDecimalPlaces(6).toFixed();

export function normalizeLine(line) {
  return { ...line, lineId: line.lineId || line.line_id || crypto.randomUUID(),
    inputMode: line.inputMode || line.input_mode || 'modal',
    discount_before: line.discount_before || discountDefault(), discount_after: line.discount_after || discountDefault(),
    tax: line.tax || { enabled: false, rate: '0', price_mode: 'exclusive' },
    invoice_discount_eligible: line.invoice_discount_eligible ?? true,
    compatibilityWarning: line.compatibilityWarning || ((!line.discount_before && line.discount != null) || (!line.tax && (line.ppn != null || line.tax_rate != null))) };
}

export function importedPurchaseLine(item) {
  const cost = String(item.cost ?? 0);
  return normalizeLine({ product_id: item.product_id, name: item.name, qty: Number(item.qty),
    baseCost: cost, cost, inputMode: item.input_mode || 'modal',
    subtotal: item.input_subtotal != null ? String(item.input_subtotal) : multiplyMoney(item.qty, cost),
    units: item.units || [], baseUnit: item.base_unit || 'Pcs', unit: item.base_unit || 'Pcs', pieces: 1,
    supplierAuto: false });
}

export function newLine(product, rate) {
  const units = (product.units || []).filter(unit => Number.isInteger(Number(unit.pieces)) && Number(unit.pieces) > 0);
  const baseUnit = product.base_unit || 'Pcs';
  const preferred = product.default_purchase_unit === baseUnit ? null : (units.find(unit => unit.name === product.default_purchase_unit)
    || units.find(unit => unit.name.toUpperCase() === 'DUS'));
  const pieces = preferred?.pieces || 1;
  const cost = multiplyMoney(product.cost || 0, pieces);
  return normalizeLine({ inputMode: 'subtotal', subtotal: cost, product_id: product.id, name: product.name, barcode: product.barcode || '', qty: 1,
    baseCost: product.cost || 0, cost, units, baseUnit,
    unit: preferred?.name || baseUnit, pieces,
    // PPN is opt-in for each new purchase line; the operator can add it explicitly.
    tax: { ...(product.purchase_tax || {}), enabled: false, rate: product.purchase_tax?.rate ?? rate, price_mode: product.purchase_tax?.price_mode || 'exclusive' } });
}

export function samePurchaseAttributes(left, right) {
  return left.product_id === right.product_id && left.unit === right.unit && Number(left.pieces) === Number(right.pieces)
    && decimal(left.cost).eq(decimal(right.cost)) && left.inputMode === right.inputMode
    && JSON.stringify(left.discount_before) === JSON.stringify(right.discount_before)
    && JSON.stringify(left.discount_after) === JSON.stringify(right.discount_after)
    && JSON.stringify(left.tax) === JSON.stringify(right.tax)
    && left.invoice_discount_eligible === right.invoice_discount_eligible;
}

export function calculationInput(lines, invoiceDiscount) {
  return { items: lines.map(line => ({ line_id: line.lineId, product_id: line.product_id, name: line.name,
    barcode: line.barcode || '', base_unit: line.baseUnit || 'Pcs', qty: line.qty === '' ? 0 : Number(line.qty),
    unit: line.unit, pieces: Number(line.pieces), cost: String(line.cost || 0), input_mode: line.inputMode,
    input_subtotal: line.inputMode === 'subtotal' ? String(line.subtotal || 0) : null,
    discount_before: { ...line.discount_before, value: decimalInput(line.discount_before.value || 0) },
    discount_after: { ...line.discount_after, value: decimalInput(line.discount_after.value || 0) },
    tax: { ...line.tax, rate: decimalInput(line.tax.rate || 0) }, invoice_discount_eligible: line.invoice_discount_eligible,
  })), invoice_discount: { ...invoiceDiscount, value: decimalInput(invoiceDiscount.value || 0) } };
}
